import { useMemo } from "react";
import { currentFixture } from "../utils/fixture";
import { useSelector } from "react-redux";

const useSelectedRaceFixture = (
  selectedRaceOption,
  isPreviousFixtureOnEosForAllRaces
) => {
  const fixtureCircuitConfigState = useSelector(
    (state) => state.fixtureCircuitConfig
  );
  const fixtures = fixtureCircuitConfigState?.data?.fixtures;

  const selectedRaceFixture = useMemo(() => {
    const selectedRaceGamedayId = selectedRaceOption?.id;
    if (selectedRaceGamedayId === 0) {
      if (isPreviousFixtureOnEosForAllRaces) {
        return fixtures?.[fixtures?.length - 1];
      }
      return currentFixture(fixtures);
    } else {
      return fixtures?.find(
        (fixture) => fixture?.GamedayId === selectedRaceGamedayId
      );
    }
  }, [selectedRaceOption, fixtures, isPreviousFixtureOnEosForAllRaces]);

  return selectedRaceFixture;
};

export default useSelectedRaceFixture;
